var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9553 0L13.6521 4.64618H13.0806L11.9553 2.04761L10.8299 4.64618H10.2585L11.9553 0Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33331 1.85602L9.53738 4.96145L9.0748 5.18088L7.14089 3.51078L7.25556 6.04323L6.79395 6.26361L6.33331 1.85602Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30609 5.45001L6.05051 6.72342L5.76674 7.07028L3.585 6.46567L4.65109 8.43759L4.36732 8.78445L2.30609 5.45001Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100159 10.1528L3.84554 9.74463L3.73767 10.1777L1.69491 10.5409L3.31104 11.8814L3.2022 12.3135L0.100159 10.1528Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8543 1.92596L14.6133 4.99403L15.072 5.21728L17.0273 3.57115L16.8825 6.10168L17.3402 6.32589L17.8543 1.92596Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7289 5.44434L17.9854 6.72062L18.2692 7.06556L20.4499 6.46L19.3858 8.43383L19.6696 8.77973L21.7289 5.44434Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8824 9.94008L20.1293 9.60089L20.2459 10.0311L22.2955 10.3569L20.7046 11.7271L20.8212 12.1573L23.8824 9.94008Z",
    fill: "#FFC700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.102 5.13757C16.4907 5.13757 20.0486 8.64448 20.0486 12.9716C20.0486 17.2987 16.4907 20.8066 12.102 20.8066C7.71328 20.8066 4.15546 17.2977 4.15546 12.9716C4.15546 8.64448 7.71328 5.13757 12.102 5.13757ZM12.102 6.75497C8.61999 6.75497 5.79686 9.53846 5.79686 12.9716C5.79686 16.4057 8.61999 19.1901 12.102 19.1901C15.584 19.1901 18.4072 16.4057 18.4072 12.9716C18.4072 9.53846 15.584 6.75497 12.102 6.75497Z",
    fill: "#FFC700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9553 26L13.6521 21.3529H13.0806L11.9553 23.9524L10.8299 21.3529H10.2585L11.9553 26Z",
    fill: "#FFC700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54907 24.2408L9.69873 21.0836L9.23323 20.8719L7.32847 22.5736L7.40038 20.0392L6.93391 19.8275L6.54907 24.2408Z",
    fill: "#FFC700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06317 20.2452L5.84645 19.0906L5.57337 18.7351L3.37415 19.2698L4.50243 17.3333L4.23129 16.9769L2.06317 20.2452Z",
    fill: "#FFC700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.4342L3.72886 15.9727L3.63654 15.5367L1.60641 15.1017L3.27016 13.8187L3.17784 13.3828L0 15.4342Z",
    fill: "#FFC700"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4908 24.2408L14.3401 21.0836L14.8056 20.8719L16.7124 22.5736L16.6404 20.0392L17.1059 19.8275L17.4908 24.2408Z",
    fill: "#FFC700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9573 20.2711L18.1769 19.105L18.45 18.7514L20.6492 19.2928L19.5248 17.3515L19.7979 16.997L21.9573 20.2711Z",
    fill: "#FFC700"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15.6096L20.2634 16.0925L20.3625 15.6575L22.3984 15.2532L20.7541 13.9462L20.8542 13.5103L24 15.6096Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.8ea91a5bbec76cfea0b46b3b9b45cd2b.svg";
export { ForwardRef as ReactComponent };